// extracted by mini-css-extract-plugin
export default {"sidebar":"_yj2pvi","highlighted-item":"_w56nvv","highlightedItem":"_w56nvv"};